module.exports = __webpack_public_path__ + "img/zenbook-a14.7f0b90dd.jpg";